<template>
	<div class="classCon">
		<div class="class" :class="{flexs:type==1}" @click.stop=''>
			<div class="left" :style="{height:type==1?'240px':type==4?'198px':'390px'}" :class="{policyR:type==3}">
				<div class="leftul" :class="{scrolls:type==1||type==4}">
					<div v-for="(item,index) of leftList" :key="index" class="leftli">
						<div v-if="type!=1&&classId==item.id" class="line"></div>
						<div class="title" @click.stop='openclass(item.id)'
							:style="{color:classId==item.id?'#51A190':''}">
							{{type==3?item.title:item.type_name}}
						</div>
						<div v-if="type==2" class="ul">
							<div class="li" @click="goSearch(item.child[0].id)">
								{{item.child[0].type_name}}
							</div>
							<div class="li" v-if="item.child.length>1" @click="goSearch(item.child[1].id)">
								{{item.child[1].type_name}}
							</div>
						</div>
						<img v-if="classId==index" src="@/static/rightsIcon.png" class="icon" />
						<img v-else src="@/static/rightIcon.png" class="icon" />
					</div>
				</div>
				<div v-if="type==2" class="bottom">
					<div class="page">
						{{page}}/{{pageTotal}}
					</div>
					<div class="buttonG">
						<img src="@/static/left.png" class="icon" @click="adjustPage(2)" />
						<img src="@/static/right.png" class="icon" @click="adjustPage(1)" />
					</div>
				</div>
			</div>

			<div class="right" :style="{height:type==1?'240px':type==4?'198px':'390px'}">
				<div  class="title">
					{{rightName}}
				</div>
				<div class="ul">
					<div v-for="(item,index) of rightList" :key="index" class="li" @click="goSearch(item.id)">
						{{type==3?item.title:item.type_name}}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['type'],// 1.首页 2.首页弹出层 3.政策中心 4.职位搜索弹出层
		name: 'class',
		data() {
			return {
				list:[],
				classId: 1, //分类id
				pageTotal: 0,
				page: 0,
				assemList: [], //分组数组
				assemIndex: 0, //分组数组下标
				leftList: [],
				rightList:[],
				rightName:''
			}
		},
		created() {
			this.getClass()
		},
		methods: {
			openclass(id) {
				this.classId = id
				let index=this.list.findIndex((item)=>{
						return id==item.id
				})
				
				if(this.type==3){
					this.rightName=this.list[index].title
				}else{
					this.rightName=this.list[index].type_name
				}
				this.rightList=this.list[index].child
			},
			getClass() {
				let url='/api/client/Common/getPositionType'
				if(this.type==3){
					url='/api/client/Policy/getClassification'
				}
				this.$axios.get(url).then(res => {
					let newVal = res.data
					if (newVal.length > 0) {
						this.list=res.data
						if (this.type == 1) {
							this.leftList = newVal
							this.rightList=this.leftList[0].child
							this.rightName=this.leftList[0].type_name
							this.classId = this.leftList[0].id
						}else if (this.type == 3) {
							this.leftList = newVal
							this.rightList=this.leftList[0].child
							this.rightName=this.leftList[0].title
							this.classId = this.leftList[0].id
						}else{
							this.pageTotal = Math.round(newVal.length / 7)
							this.page = 1
							let newArrayGroup = [];
							let tempArray = [];
							// 将原始数组按照每7个元素分组
							for (let i = 0; i < newVal.length; i++) {
								tempArray.push(newVal[i]);
								if ((i + 1) % 7 === 0 || i === newVal.length - 1) {
									newArrayGroup.push(tempArray);
									tempArray = [];
								}
							}
							// 打印每组的数组
							// 将所有新数组放入一个总的数组中
							const totalArray = [];
							for (let j = 0; j < newArrayGroup.length; j++) {
								totalArray.push(newArrayGroup[j]);
							}
							this.assemList = totalArray
							this.leftList = this.assemList[this.assemIndex]
							this.rightList=this.assemList[this.assemIndex][0].child
							this.rightName=this.leftList[0].type_name
							this.classId = this.leftList[0].id
						}
						
					}
				})
			},
			// 前进后退 1加 2减
		    adjustPage(value){
				if(value==1){
					if(this.page==this.pageTotal){
						this.page=1
					}else{
						this.page++
					}
					
				}else{
					if(this.page==1){
						this.page=this.pageTotal
					}else{
						this.page--
					}
				}
				this.setList()
			},
			// 重组数组
			setList(){
				this.leftList = this.assemList[this.page-1]
			},
			// 跳转到搜索
			goSearch(id){
				if(this.type==1||this.type==2){
					this.$router.push({ name: 'Search', params: { id: id } });
					return
				}
				
				if(this.type==3){
					this.$router.push({ name: 'policySearch', query: { id: id } });
				}
				
				if(this.type==4){
					this.$emit('selectId',id)
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.classCon {
		overflow: hidden;

		.flexs {
			width: 896px;

			.left {
				flex: 1;
				box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
			}

			.right {
				flex: 3 !important;
			}
		}

		.policyR {
			margin-right: 8px;
			width: 203px !important;
		}

		.class {
			display: flex;
			align-items: center;

			::-webkit-scrollbar {
				width: 0.1em;
			}


			.scrolls {
				overflow: scroll;
				overflow-x: hidden;
			}

			.left {
				width: 440px;
				height: 390px;
				background-color: #fff;
				border-radius: 16px;
				padding: 18px 0 12px;
				box-sizing: border-box;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.leftul {
					.leftli {
						padding: 0 22px;
						display: flex;
						align-items: center;
						position: relative;
						justify-content: space-between;
						margin-bottom: 25px;

						&:last-child {
							margin-bottom: 0;
						}

						.line {
							width: 4px;
							height: 20px;
							background-color: #9B6CFF;
							border-radius: 16px;
							position: absolute;
							left: 9px;
							top: 50%;
							transform: translate(0, -50%);
						}

						.title {
							margin-right: 24px;
							color: #151515;
							font-size: 17px;
							font-weight: bold;
							cursor: pointer;
						}

						.ul {
							display: flex;
							align-items: center;
							flex: 1;

							.li {
								color: #666666;
								font-size: 15px;
								cursor: pointer;

								&:hover {
									color: #51A190;
								}

								margin-right: 10px;

								&:last-child {
									margin-right: 0;
								}
							}
						}
					}
				}

				.bottom {
					display: flex;
					align-items: center;
					padding: 0 22px;
					justify-content: space-between;

					.page {
						font-size: 16px;
						color: #51A190;
					}

					.buttonG {
						.icon {
							cursor: pointer;
							width: 28px;
							height: 28px;
							margin-right: 14px;

							&:last-child {
								margin-right: 0;
							}
						}
					}
				}
			}

			.right {
				flex: 1;
				height: 390px;
				border: 2px solid #9B6CFF;
				border-radius: 16px;
				background-color: #FFF;
				box-sizing: border-box;
				padding: 19px 21px;
				overflow: scroll;
				overflow-x: hidden;

				.title {
					color: #9B6CFF;
					font-size: 17px;
					margin-bottom: 18px;
					font-weight: bold;
				}

				.ul {
					display: flex;
					align-items: center;
					flex-wrap: wrap;

					.li {
						margin-right: 28px;
						margin-bottom: 18px;
						cursor: pointer;
						font-size: 15px;
						color: #666666;
						&:hover {
							color: #51A190;
						}
					}
				}
			}
		}
	}
</style>